export default __webpack_public_path__ + "static/media/designer.3c0cd471.png";